<template>
    <section class="tables">
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Focus Action</h4>
                    </div>
                    <div class="card-body">
                        <div class="col-md-12 grid-margin">
                            <h1 class="text-center heading_focus border-bottom">{{ focus.FocusName }}</h1>
                            <h4>Defined:</h4>
                            <ul v-html="definations"> </ul>
                            <h4>Action Steps:</h4>
                            <ul v-html="actionSteps"> </ul>

                            <h4>Success Rate Target:</h4>
                            <ul>
                                <li>
                                    {{ focus.Target }}%
                                </li>
                            </ul>

                            <h4>Benefits:</h4>
                            <ul v-html="benefits"></ul>

                            <h4>Track Your Success:</h4>
                            <router-link :to="{name:'focus_action'}" class="btn btn-primary"> <i
                                    class="fa fa-arrow-left"></i> Back</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import router from '../../router';



export default {
    name: 'view_focus',
    data() {
        return {
            focus: {},
        };
    },

    mounted() {
        this.getFoucs()
    },
    methods: {
        getFoucs() {
            if (this.$route.params.focus) {
                this.focus = this.$route.params.focus;
            } else {
                router.push({ name: "focus_action" });
            }
        },
    }, computed: {
        definations() {
            let defination = '';
            for (let i = 1; i <= 2; i++) {
                let exist = this.focus[`Definition${i}`];
                if (exist != null || exist != '') {
                    defination += `<li>${exist}</li>`;
                }
            }
            return defination;
        },

        actionSteps() {
            let actions = '';
            for (let i = 1; i <= 6; i++) {
                let exist = this.focus[`ActionStep${i}`];
                if (exist != null || exist != '') {
                    actions += `<li>${exist}</li>`;
                }
            }
            return actions;
        },

        benefits() {
            if (this.focus.Benefits != '' || this.focus.Benefits != null) {
                return `<li>${this.focus.Benefits}</li>`
            } else {
                return `<li>N/A</li>`
            }
        }
    }
}
</script>
<style>
h1.heading_focus {
    font-size: 30px;
    margin-bottom: 30px;
    padding-bottom: 20px;
    margin-top: 0;
}
</style>
